<template>
    <div>
        <ProfileBlock :title="$t('components.consents_edit.block_name')">
            <FormulateForm
                id="consents-form"
                @submit="submit"
                class="sm:divide-y"
            >
                <div v-for="(option, key) in options" :key="key">
                    <FormulateInput
                        type="switchbox"
                        class="py-4"
                        :label="option.label"
                        :value="option.value"
                        v-model="value"
                    />
                </div>
            </FormulateForm>
            <template v-slot:block-link>
                <button type="submit" form="consents-form">
                    {{ $t("components.consents_edit.save_button") }}
                </button>
            </template>
        </ProfileBlock>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import ProfileBlock from "@/components/profile/ProfileBlock";

export default {
    name: "ConsentsEdit",
    methods: {
        submit() {
            this.update().then(() => {
                this.$toast.success(
                    this.$t(
                        "components.consents_edit.success_message"
                    ).toString()
                );
            });
        },
        ...mapActions({
            fetch: "profile/consents/fetch",
            fetchConsent: "profile/consents/fetchConsent",
            update: "profile/consents/update"
        }),
        ...mapMutations({
            UPDATE_CONSENTS: "profile/consents/UPDATE_CONSENTS"
        })
    },
    computed: {
        value: {
            get() {
                return this.consents
                    .filter(consent => consent.is_granted)
                    .map(consent => consent.id);
            },
            set(value) {
                this.UPDATE_CONSENTS(value);
            }
        },
        options() {
            return this.consents.map(consent => ({
                value: consent.id,
                label: consent.body
            }));
        },
        ...mapGetters({
            consents: "profile/consents/consents"
        })
    },
    mounted() {
        if (this.$route.params.consent_id) {
            this.fetchConsent({ consent_id: this.$route.params.consent_id });
        } else {
            this.fetch();
        }
    },
    components: { ProfileBlock }
};
</script>

<style scoped></style>
